import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext.tsx';
import { ToastProvider } from './context/ToastContext.tsx';
import { DialogProvider } from './context/DialogContext.tsx';
import { TranslationProvider } from './context/TranslationProvider.tsx';
import { SidebarProvider } from './context/SidebarProvider.tsx';
import { CartProvider } from './context/CartProvider.tsx';
import { TransitDialogProvider } from './context/TransitDialogContext.tsx';
import { BottomDialogProvider } from './context/BottomDialogContext.tsx';
import { MyDialogProvider } from './context/MyDialogProvider.tsx';

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TranslationProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
                <ToastProvider>
                  <TransitDialogProvider>
                    <BottomDialogProvider>
              <MyDialogProvider>
                      <DialogProvider>
                        <SidebarProvider>
                          <App />
                        </SidebarProvider>
                      </DialogProvider>
              </MyDialogProvider>
                    </BottomDialogProvider>
                  </TransitDialogProvider>
                </ToastProvider>
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </QueryClientProvider>
    </TranslationProvider>
  </StrictMode>
);
